import { render } from "./FormTrainingItemFields.vue?vue&type=template&id=53673968&scoped=true&ts=true"
import script from "./FormTrainingItemFields.vue?vue&type=script&lang=ts"
export * from "./FormTrainingItemFields.vue?vue&type=script&lang=ts"

import "./FormTrainingItemFields.vue?vue&type=style&index=0&id=53673968&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53673968"]])

export default __exports__